import { useGetWhoamiQuery } from "Services";
import { AiConfig } from "Types";

type AiFeatureFlag = keyof Omit<AiConfig, "ai_enabled">;

// Mirrors the backend gate: a feature is usable only when the master switch (ai_enabled)
// and the feature's own flag are both on.
const useIsAiFeatureEnabled = (feature: AiFeatureFlag): boolean => {
  const { data: whoami } = useGetWhoamiQuery();
  const aiConfig = whoami?.ai_config;

  return Boolean(aiConfig?.ai_enabled && aiConfig[feature]);
};

export default useIsAiFeatureEnabled;
